const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getAllTemplates = async (limit, offSet, searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
      `personal/templates?limit=${limit}&offset=${offSet}&layoutType=userTemplate&search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL +
      `personal/templates?limit=${limit}&offset=${offSet}&layoutType=userTemplate`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getTemplateInfoById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/templates/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllAssets = async (offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/assets?limit=8&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllAssetsNoLimit = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/assets`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllAssetsCount = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/assets/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllTemplatesCount = async (searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
      `personal/templates/totalCount?search=${searchText}&layoutType=userTemplate`
      : process.env.REACT_APP_API_BASE_URL + `personal/templates/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllTemplatesCountByTag = async (tag) => {
  const response = await axios.get(process.env.REACT_APP_API_BASE_URL + `personal/templates/count?tag=${tag}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};
export const getAllTemplatesPublishedContentCount = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/templates/count?type=publishedContent`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllTemplatesCountByType = async (value) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/templates/count?type=${value}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllEmailTemplatesTheme = async (limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/templates?layoutType=emailTheme&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllBlogTemplatesTheme = async (limit, offSet, tag) => {
  const response = await axios.get(
    tag ? process.env.REACT_APP_API_BASE_URL +
      `personal/templates?layoutType=blog&limit=${limit}&offset=${offSet}&tag=${tag}` : process.env.REACT_APP_API_BASE_URL +
    `personal/templates?layoutType=blog&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllCalculatorTemplatesTheme = async (limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/templates?layoutType=calculator&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllOffers = async (limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/templates?layoutType=offer&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const uploadAsset = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `personal/assets/upload`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const testTemplate = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/templates/${id}/test`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getTemplates = async (type, layouttype, limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/templates?type=${type}&layoutType=${layouttype}&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const deleteTemplate = async (id) => {
  const response = await axios({
    method: "delete",
    url: process.env.REACT_APP_API_BASE_URL + `personal/templates/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};

export const saveTemplate = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `personal/templates`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const addToCartTemplate = async (id) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `personal/templates/${id}/addToCart`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};

export const getTemplateTags = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/templates/tags`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};
